(() => {
  // Remove only a repeated document title, never policy sections or clauses.
  document.querySelectorAll('[data-privacy-policy], [data-terms-policy]').forEach(root => {
    const title = root.querySelector('.shopify-policy__title h1');
    const body = root.querySelector('.shopify-policy__body');
    if (!title || !body) return;
    const terms = root.hasAttribute('data-terms-policy');
    title.textContent = terms ? 'Terms & Conditions' : 'Privacy Policy';
    const first = body.querySelector('h1,h2');
    const aliases = terms ? ['terms of service','terms & conditions','terms and conditions'] : ['privacy policy'];
    if (first && aliases.includes(first.textContent.trim().toLowerCase())) first.remove();
  });
})();
